import { RPDF, Text, View } from '../common/react-pdf';
import React from 'react';

interface Props {
  text: string;
}

export const ReportInfoTitle: React.FC<Props> = (props) => {
  return (
    <RPDF.View style={RPDF.styles.titleContainer}>
      <RPDF.Text style={RPDF.styles.titleText}>{props.text}</RPDF.Text>
    </RPDF.View>
  );
};
